import React from 'react';
import { observer } from 'mobx-react';
import { withStore } from "../../hocs";
import { Link, useLocation } from 'react-router-dom';
import { ISectionMenuL1, ISectionMenuL2 } from '../../interface/ISection';
import { HelperCatalog } from "../../helper/HelperCatalog";


// @ts-ignore
@withStore
@observer
export class SidebarLeft extends React.Component {
    state = {
        hoveredSectionId: null as number | null,
        hoveredItemId: null as number | null
    };

    handleSectionMouseEnter = (sectionId: number) => {
        this.setState({ hoveredSectionId: sectionId, hoveredItemId: null });
    };

    handleSectionMouseLeave = () => {
        this.setState({ hoveredSectionId: null, hoveredItemId: null });
    };

    handleItemMouseEnter = (itemId: number) => {
        this.setState({ hoveredItemId: itemId });
    };

    handleItemMouseLeave = () => {
        this.setState({ hoveredItemId: null });
    };

    render() {

        // @ts-ignore
        const { store } = this.props;
        const { arSection } = store?.componentCatalogSectionStore;
        const { setPageCatalogL1, setPageCatalogL2 } = store?.pageCatalogStore;
        const { includeUserLoyaltyProgram } = store?.mainStore;

        // Получаем текущий URL и декодируем его
        const location = decodeURIComponent(window.location.pathname);

        // Функция для проверки, содержит ли URL код секции
        const isSectionActive = (lev1: ISectionMenuL1) => {
            // Проверяем, содержит ли URL lev1.code
            if (location.includes(lev1.code)) {
                return true;
            }
        };

        const isSectionActiveLev2 = (code: string) => {
            // Проверяем, содержит ли URL lev1.code
            if (location.includes(code)) {
                return true;
            }
        };

        // Функция для определения активного состояния секции (hover имеет приоритет)
        const getSectionActiveState = (lev1: ISectionMenuL1) => {
            const isHovered = this.state.hoveredSectionId === lev1.id;
            const isUrlActive = isSectionActive(lev1);
            
            return isHovered || isUrlActive;
        };

        // Функция для определения активного состояния элемента (hover имеет приоритет)
        const getItemActiveState = (lev2: ISectionMenuL2) => {
            const isHovered = this.state.hoveredItemId === lev2.id;
            const isUrlActive = isSectionActiveLev2(lev2.code);
            
            return isHovered || isUrlActive;
        };

        return (
            <>
                {arSection.length ? <div className="sidebar sidebar_left">
                    <Link to="/catalog/filter/isSellout-is-true">
                        <button style={{ marginTop: 31, marginBottom: 0, width: "100%", backgroundColor: "#E1EFFA", }} className="to-basket__btn " >
                            <span style={{ color: "red", fontWeight: "bold" }} className="to-basket__text ">% РАСПРОДАЖА</span>
                        </button>
                    </Link>
                    {includeUserLoyaltyProgram ? <Link to="/catalog/filter/isIncludeLoyaltyProgram-is-true">
                        <button style={{ marginTop: 21, marginBottom: -10, width: "100%", backgroundColor: "#E1EFFA", }} className="to-basket__btn " >
                            <span style={{ color: "black", fontWeight: "bold", display: "flex", }} className="to-basket__text ">
                                <img src="/img/ico/bonusIcon.png"
                                     width="20px"
                                     style={{ mixBlendMode: 'multiply', marginRight: 5 }} />
                                <div style={{ marginTop: 5 }}>
                                    БОНУСНЫЕ ТОВАРЫ
                                </div>

                            </span>
                        </button>
                    </Link> : null}

                    <div className="sidebar-wrapper">
                        {arSection.map(((lev1: ISectionMenuL1, index: number) => {
                            const isActive = getSectionActiveState(lev1);
                            return (
                                <div 
                                    className={`sidebar-item ${isActive ? 'hover' : ''}`} 
                                    key={'l1' + lev1.id}
                                    onMouseEnter={() => this.handleSectionMouseEnter(lev1.id)}
                                    onMouseLeave={this.handleSectionMouseLeave}
                                >
                                    <Link to={HelperCatalog.getUrlList(lev1, null)}>
                                        {lev1.svgSectionLeft}
                                    </Link>
                                    <div className="sidebar-wrapper-bg">
                                        <Link to={HelperCatalog.getUrlList(lev1, null)}
                                              className="sidebar-item__title">{lev1.name}</Link>
                                    </div>
                                    {isActive && lev1.SectionChild.length ? (
                                        <ul className="sidebar-menu hover">
                                            {lev1.SectionChild.map((lev2: ISectionMenuL2) => {
                                                const isActive2 = getItemActiveState(lev2);
                                                return (
                                                    <li 
                                                        key={'l2' + lev2.id} 
                                                        style={isActive2 ? {
                                                            background: 'white',
                                                            borderBottom: '1px solid #E3ECF2'
                                                        } : {}} 
                                                        onMouseEnter={() => this.handleItemMouseEnter(lev2.id)}
                                                        onMouseLeave={this.handleItemMouseLeave}
                                                    >
                                                        <Link 
                                                            to={HelperCatalog.getUrlList(lev1, lev2)}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <span style={isActive2 ? { color: '#489ff0' } : {}}>{lev2.name}</span>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                            )}
                                        </ul>
                                    ) : null}
                                </div>
                            );
                        }))}
                    </div>
                    <Link to="/brands">
                        <button style={{ marginTop: 20, width: "100%" }} className="to-basket__btn " >
                            <span className="to-basket__text ">НАШИ БРЕНДЫ</span>
                        </button>
                    </Link>

                </div> : null}
            </>
        );
    }
}


